import React, { FC, Suspense, useContext, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useHistory } from "react-router";
// custom Components import
import AuthImage from "./assets/images/authImage.png";
import Loader from "./components/loaders/pageLoader";
// routes
import { routes } from "./routes.path";
import { FormLeft } from "./modules/Auth/Components/style";
import Aside from "./modules/navigator/aside";
import Header from "./modules/navigator/header";
import OfflineComponent from "./modules/navigator/OfflineComponent";
import PrivateRoute from "./modules/navigator/privateRoute";
import PrivateRouteAuth from "./modules/navigator/privateRouteAuth";
import { Cover } from "./modules/navigator/header.style";
// services
import SystemContext from "./context/systemContext";
import RoleManager from "./services/roleManagement";
import browserStorage from "./services/storage";
import useNetwork from "./services/useNetwork/useNetwork";

const Routes: FC<{}> = () => {
  const [hasAccess] = RoleManager();
  const history = useHistory();
  const check: boolean =
    history.location.pathname === "/" ||
    history.location.pathname === "/sign-verify" ||
    history.location.pathname === "/sign-with-password" ||
    history.location.pathname === "/password" ||
    history.location.pathname === "/forget-password";
  const { online, since } = useNetwork();
  const [collapse, setCollapse] = useState<boolean>(true);
  const { orgSettings, roles } = useContext<any>(SystemContext);

  if (!check) {
    if (!browserStorage.get("token")) return <Redirect to="/" />;
  }

  return (
    <Suspense
      fallback={
        <div className="position-relative" style={{ height: "100vh" }}>
          <Loader />
        </div>
      }
    >
      <Cover>
        {!check ? (
          <Aside collapse={collapse} setCollapse={setCollapse} />
        ) : (
          <FormLeft className="h-100">
            {/* <img src={AuthImage} className="w-100 h-100" alt="AuthImage" /> */}
          </FormLeft>
        )}

        {!check ? (
          <div
            className={`${!collapse ? "rightContent" : "rightContentSmall"}`}
          >
            {/* <div
              style={{
                backgroundColor: "yellow",
                textAlign: "center",
                fontSize: 15,
              }}
            >
              Bugun 22:00 dan ertaga 8:00 gacha texnik ishlar olib boriladi
            </div> */}
            <Header />
            {online ? (
              <>
                <Switch>
                  {routes
                    ?.filter(
                      (item: any) =>
                        orgSettings[item.showKey] ||
                        item.showKey === "settings" ||
                        item.showKey === "monitoring_statistic" ||
                        (item.showKey === "monitoring" && roles?.isBoss)
                    )
                    ?.map((route: any, index: number) => {
                      return route.private ? (
                        // hasAccess(route.id) && (
                        <PrivateRoute key={route.id} exact {...route}>
                          <Route key={index.toString()} exact {...route} />
                        </PrivateRoute>
                      ) : (
                        // )
                        // hasAccess(route.id) && (
                        <PrivateRouteAuth key={route.id} exact {...route}>
                          <Route key={index.toString()} exact {...route} />
                        </PrivateRouteAuth>
                        // )
                      );
                    })}
                </Switch>
              </>
            ) : (
              <OfflineComponent />
            )}
          </div>
        ) : (
          <>
            <Switch>
              {routes.map((route: any, index: number) => {
                return route.private ? (
                  // hasAccess(route.id) && (
                  <PrivateRoute key={route.id} exact {...route}>
                    <Route key={index.toString()} exact {...route} />
                  </PrivateRoute>
                ) : (
                  // )
                  // hasAccess(route.id) && (
                  <PrivateRouteAuth key={route.id} exact {...route}>
                    <Route key={index.toString()} exact {...route} />
                  </PrivateRouteAuth>
                  // )
                );
              })}
            </Switch>
          </>
        )}
        <Toaster containerStyle={{ zIndex: "99999999999" }} />
      </Cover>
    </Suspense>
  );
};

export default Routes;
